import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'

export interface ActivityItem {
  ts: string
  kind: 'stage' | 'application' | 'invitation' | 'intake' | 'comment'
  demand_id: number
  demand_title: string
  fa_code?: string | null
  /** null when the source has no actor — or when the viewer is outside the
   *  demand's FA and the actor is a talent (#1044). Render "Someone". */
  actor_name?: string | null
  from_stage?: string | null
  to_stage?: string | null
}

/** Aggregate activity (#1220): one FA (`fa` set) or across all (`fa` undefined). */
export function useActivity(fa: string | undefined, limit: number) {
  return useQuery<ActivityItem[]>({
    queryKey: ['activity', fa ?? 'all', limit],
    queryFn: async () => {
      const res = await api.get<{ items: ActivityItem[] }>('/activity', {
        params: fa ? { fa, limit } : { limit },
      })
      return res.data.items
    },
    staleTime: 60 * 1000,
  })
}
